import { Drawer, Box, Typography, Divider, List, ListItem, ListItemText, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const CartDrawer = ({ isOpen, onClose, cart, onRemove, onUpdateQty, total, onCheckout }) => {
  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ width: { xs: '300px', sm: '380px' }, p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>Tu Carrito</Typography>
        <Divider />
        
        <List sx={{ flexGrow: 1, overflowY: 'auto', mt: 1 }}>
          {cart.length === 0 ? (
            <Typography sx={{ textAlign: 'center', py: 10, color: '#999' }}>El carrito está vacío</Typography>
          ) : (
            cart.map(item => (
              <ListItem 
                key={item._id} 
                sx={{ px: 0, borderBottom: '1px solid #f9f9f9' }}
                secondaryAction={
                  <IconButton edge="end" onClick={() => onRemove(item._id)}>
                    <DeleteIcon sx={{ color: '#ff4d4d', fontSize: '20px' }} />
                  </IconButton>
                }
              >
                <ListItemText 
                  primary={item.nombre} 
                  secondary={`BOB ${item.precio.toFixed(2)}`} 
                  primaryTypographyProps={{ fontWeight: 'bold', fontSize: '14px' }}
                />
                <Box sx={{ display: 'flex', alignItems: 'center', mr: 4 }}>
                  <IconButton size="small" onClick={() => onUpdateQty(item._id, -1)}><RemoveIcon fontSize="small" /></IconButton>
                  <Typography sx={{ mx: 1, fontWeight: 'bold', fontSize: '14px' }}>{item.quantity}</Typography>
                  <IconButton size="small" onClick={() => onUpdateQty(item._id, 1)}><AddIcon fontSize="small" /></IconButton>
                </Box>
              </ListItem>
            ))
          )}
        </List>

        {cart.length > 0 && (
          <Box sx={{ pt: 2 }}>
            <Divider sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Total Estimado:</Typography>
              <Typography variant="h6" sx={{ fontWeight: 900 }}>BOB {total.toFixed(2)}</Typography>
            </Box>
            
            <Button 
              fullWidth variant="contained" color="success" 
              startIcon={<WhatsAppIcon />} 
              onClick={onCheckout}
              sx={{ py: 1.5, fontWeight: 'bold', borderRadius: 2, textTransform: 'none', fontSize: '16px' }}
            >
              Finalizar Pedido
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default CartDrawer;